// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login-title {\n    font-size: 26px !important;\n}\n", ""]);
// Exports
module.exports = exports;
